import React, { useEffect, useState } from "react";
import { Paper, Grid, Typography } from "@material-ui/core";
import useStyles from "../../styles/deviceStyle";
import { useTranslation } from "../../langs/useTranslation";
import { useParams } from "react-router-dom";
import { Line } from "react-chartjs-2";
import { dataSet, cpuTempOptions } from "../../helpers/chartDataSet";
import { getRealTimeDataAPI } from "../../apis/getRealTimeDataAPI";
import SmallerLoadingIndicator from "../commons/SmallerLoadingIndicator";
import { chartColors } from "./../../helpers/commonHelper";
import dayjs from "dayjs";
import useStateOnMounted from "../../helpers/useStateOnMounted";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import {
  cpuTemperatureTimestampCherryPick,
  cpuTemperatureTimestampCherryPickInOneHour
} from "./../../helpers/timestampCherryPick";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const DeviceCpuTemperature = props => {
  const { t } = useTranslation("device");
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const { device_id } = useParams();
  const [labelArr, setLabelArr] = useStateOnMounted([]);
  const [datasets, setDatasets] = useStateOnMounted([]);
  const [date, setDate] = useStateOnMounted("");
  const [unit, setUnit] = useStateOnMounted();
  const { graphType, mins, dateInHour } = props;

  const getData = async () => {
    try {
      setLoading(true);
      let data = await getRealTimeDataAPI(device_id, graphType, mins, 1);
      /* ==== Ad-hoc Solution for datapoint reduce.(this should process at backend) ===== */
      // data = cpuTemperatureTimestampCherryPick(mins, data);
      data = cpuTemperatureTimestampCherryPickInOneHour(mins, data, dateInHour);
      /* ========== */
      if (data) {
        const unicode = "&#8451;".match(/\d+/);
        let labels =
          data &&
          data.label.map((item, index) => dayjs(item).local().format("HH:mm"));
        let datasets = data && data.dataSets;
        let newDatasets = datasets.map((item, index) => {
          let color = chartColors[index];
          return dataSet(item.data, item.label, color, color, color, color);
        });

        setLabelArr(labels);
        setDatasets(newDatasets);
        setUnit(String.fromCharCode(unicode));
        setDate(dateInHour.format("YYYY-MM-DD HH:00"));
      }
    } finally {
      setLoading(false);
    }
  };

  const data = {
    labels: labelArr,
    datasets: datasets
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mins, dateInHour]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Paper
          elevation={0}
          className={`${classes.marginBottomReset} ${classes.graphWrap}`}
        >
          <Typography
            variant="subtitle2"
            align="center"
            className={classes.graphDate}
          >
            {t("deviceInformation.date")}
            {date}
          </Typography>
          <Typography
            variant="caption"
            align="right"
            className={classes.graphUnit}
          >
            {unit}
          </Typography>
          {props.onlineStatus === "offline" ? (
            <Typography variant="caption" className={classes.offlineGraphNote}>
              Device is offline
            </Typography>
          ) : (
            ""
          )}
          <div className={classes.graphContainer}>
            {loading && (
              <SmallerLoadingIndicator className={classes.loadingWrapper} />
            )}
            <Line data={data} options={cpuTempOptions} />
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default DeviceCpuTemperature;
